// extracted by mini-css-extract-plugin
module.exports = {"button":"Pill_button__rncjZ","button_dark":"Pill_button_dark__n5N5J"};